<template>
  <v-app>
    <component :is="layout">
      <template #nav>
        <AdminNav />
      </template>
    </component>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

import BaseLayout from "@/views/layouts/BaseLayout";
import AuthLayout from "@/views/layouts/AuthLayout";
import AdminNav from "@/components/nav/AdminNav";

export default {
  components: {
    BaseLayout,
    AuthLayout,
    AdminNav,
  },
  computed: {
    ...mapGetters(["token"]),
    layout() {
      return this.token ? "BaseLayout" : "AuthLayout";
    },
  },
};
</script>

<style>
html {
  overflow-y: auto;
}
.error-text input {
  color: red !important;
  text-align: center;
}
.ok-text input {
  color: green !important;
  text-align: center;
}
</style>
